'use strict';

var implementation = require('./implementation');

module.exports = Function.prototype.bind || implementation;



//////////////////
// WEBPACK FOOTER
// ./~/side-channel-map/~/function-bind/index.js
// module id = 2366
// module chunks = 67